var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_935_11566",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.828369,
    y: 0.419922,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_935_11566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82837 18.4199C9.27837 18.4199 8.80754 18.2241 8.41587 17.8324C8.0242 17.4408 7.82837 16.9699 7.82837 16.4199V4.41992C7.82837 3.86992 8.0242 3.39909 8.41587 3.00742C8.80754 2.61576 9.27837 2.41992 9.82837 2.41992H18.8284C19.3784 2.41992 19.8492 2.61576 20.2409 3.00742C20.6325 3.39909 20.8284 3.86992 20.8284 4.41992V16.4199C20.8284 16.9699 20.6325 17.4408 20.2409 17.8324C19.8492 18.2241 19.3784 18.4199 18.8284 18.4199H9.82837ZM5.82837 22.4199C5.27837 22.4199 4.80754 22.2241 4.41587 21.8324C4.0242 21.4408 3.82837 20.9699 3.82837 20.4199V6.41992H5.82837V20.4199H16.8284V22.4199H5.82837Z",
    fill: "#0057B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFill);
export default __webpack_public_path__ + "static/media/copy_fill.3b8ba330977a1de8e3a027b9cb9acca7.svg";
export { ForwardRef as ReactComponent };